export const linkRegex = /<a.*?(href="|class=").*?>.*?<\/a>/g
